import { createSlice } from "@reduxjs/toolkit";

export const pests_main_crop_affected = createSlice({
  name: "pest_main_crop_affected",
  initialState: {
    value: {
      status: false,
      cropSelected: {},
    },
  },
  reducers: {
    //create first data item
    updatePestsMainCropAffected: (state, action) => {
      state.value.status = true;
      state.value.cropSelected = action.payload;
    },
  },
});

export const { updatePestsMainCropAffected } = pests_main_crop_affected.actions;

export default pests_main_crop_affected.reducer;
